import { FC, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import './style.scss'
import CONFIG from '../../../config'
import { Button, FormMessageError, Icon, Text, Title } from '../UI'
import { Modal, useModal } from '../UI/Modal'
import { userService } from '../../services'
import { profileActions } from '../../store/actions'

type ProfileDeleteProps = {
  className?: string,
  style?: any
}

const ProfileDelete:FC<ProfileDeleteProps> = ({ className = '', style }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [submited, setSubmited] = useState<boolean>(false)
  const modal = useModal(false)

  const profileDelete = async () => {
    const resp = await userService.delUserCurrent()

    if(resp && resp.status === 'Ok') {
      dispatch(profileActions.deleteProfileSw(true))
      history.push(CONFIG.ROUTES.HOME)

    } else {
      setSubmited(false)
      modal.setStatus('ERROR')
      modal.setMessage(resp && resp.message ? resp.message : '')
    }
  }

  const onDelete = () => {
    setSubmited(true)
    profileDelete()
  }

  const onDeleteConfirm = () => {
    modal.setStatus('')
    modal.open()
  }

  return (
    <>
      <div className={className} style={style}>
        <Icon name="alert" />
        <Title component="h2" size="20" weight="bold" lineHeight="4" className="lg:fz-22 mt-30">Aquí puedes eliminar tu perfil de Mi Portal INDISA</Title>
        <Text lineHeight="4" className="lg:fz-13 mt-30">Considera que al hacerlo, ya no tendrás acceso a tu información médica.</Text>
        <Button size="md" className="mt-50 lg:mt-60" onClick={onDeleteConfirm}>ELIMINAR MI PERFIL</Button>
      </div>

      <Modal show={modal.show} maxWidth="345px" onClose={() => modal.close()}>
        {modal.status === 'ERROR' ?
            <FormMessageError
              message={modal.message}
              className="pt-80 pb-70 px-15"
              onClick={() => modal.close()}
            />
          :
            <div className="text-center pt-40 pb-30 px-15">
              <Icon name="alert" />
              <Title component="h4" size="20" weight="bold" className="mt-20">¿Estás seguro que deseas eliminar tu perfil?</Title>
              <Text weight="semibold" className="mt-25">Esta acción no se puede revertir. Si deseas recuperar tu perfil tendrás que dirigirte a servicio al cliente.</Text>

              <div className="row mt-50">
                <div className="col-6 pr-5">
                  <Button size="md" fullWidth onClick={onDelete} disabled={submited}>ELIMINAR</Button>
                </div>
                <div className="col-6 pl-5">
                  <Button size="md" color="primary" fullWidth onClick={() => modal.close()}>CANCELAR</Button>
                </div>
              </div>
            </div>
        }
      </Modal>
    </>
  )
}

export { ProfileDelete }